/* eslint-disable import/prefer-default-export */
import { css } from "@emotion/react";
import { titleCss } from "assets/css/titleCss";

export const headerCss = [
  titleCss,
  css`
    &:empty {
      display: none;
    }
  `,
];
